import { Integration_Handler_Names_Enum } from '@main/graphql/types.generated';
import { timePeriodSchema } from '@main/shared/utils';
import { z } from 'zod/v4';

import { IntegrationConfig } from '../../../../../../lib';
import { GithubService } from '../../service';

export type MergedPullRequestsConfig = typeof MergedPullRequestsConfig._.Config;

export const MergedPullRequestsConfig = IntegrationConfig.make({
  service: GithubService,
  name: Integration_Handler_Names_Enum.MergedPullRequests,
  configSchema: z.object({
    repoName: z.string().min(1),
    timePeriod: timePeriodSchema,
    filterQuery: z.string().optional(),
  }),
});
